const META_PIXEL_ID = '720308051639967';
const META_PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

export const ensureMetaPixel = () => {
  if (typeof window === 'undefined' || window.__crateMetaPixelInitialized) {
    return;
  }

  window.__crateMetaPixelInitialized = true;

  if (typeof window.fbq === 'function') {
    window.fbq('init', META_PIXEL_ID);
    return;
  }

  (function(f, b, e, v, n, t, s) {
    if (f.fbq) {
      return;
    }
    n = f.fbq = function() {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) {
      f._fbq = n;
    }
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', META_PIXEL_SRC);

  window.fbq('init', META_PIXEL_ID);
};
